const COMMON = {
  SERVER_IS_NOT_RESPONDING: 'error.common.serverIsNotResponding',
  NOT_FOUND: 'error.common.pageNotFound',
  BAD_REQUEST: 'error.common.badRequest',
  UNKNOWN: 'error.common.unknown',
};
const AUTH = {
  INVALID_DATA: 'error.auth.invalidData',
  INVALID_ADMIN_DATA: 'error.auth.invalidAdminData',
  EMPTY_DATA: 'error.auth.emptyData',
  UNAUTHORIZED: 'error.auth.unauthorized',
  FORBIDDEN: 'error.auth.forbidden',
};

export const STATUS_CODE: Record<string, number> = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  TOO_MANY_REQUESTS: 429,
  SERVER: 500,
};

export const ErrorMessages: Record<string, Record<string, string>> = {
  COMMON,
  AUTH,
};

export const MAPPING_ERROR_STATUS_CODE_AND_ERROR_DATA: Record<number, Record<string, string>> = {
  [STATUS_CODE.UNAUTHORIZED]: {
    message: AUTH.UNAUTHORIZED,
  },
  [STATUS_CODE.FORBIDDEN]: {
    message: AUTH.FORBIDDEN,
  },

  [STATUS_CODE.NOT_FOUND]: {
    message: COMMON.NOT_FOUND,
  },
  [STATUS_CODE.BAD_REQUEST]: {
    message: COMMON.BAD_REQUEST,
  },

  [STATUS_CODE.SERVER]: {
    message: COMMON.SERVER_IS_NOT_RESPONDING,
  },
};

export const GoogleCaptchaErrorType = {
  FIRST_STEP_FAILED: 'captcha_1_failed',
  COMPLETELY_FAILED: 'captcha_2_failed',
};

export const ErrorType = {
  REQUIRED_2FA: 'missing_otp_2fa',
  INVALID_EMAIL: 'Invalid credentials',
  INVALID_PASSWORD: 'Invalid credentials1',
  INVALID_CREDENTIALS: 'invalid_credentials',
  VALIDATION_FAILED: 'Input payload validation failed',

  INVALID_AUTH_DATA: 'AuthenticationError',

  CAPTCHA_FINAL_ERROR: 'captcha_failed',
};

export const RequestErrorMessages = {
  emailAlreadyRegistered: 'error.emailAlreadyRegistered',
  incorrectTOTP: 'error.incorrectTOTP',
  incorrectPassword: 'error.incorrectPassword',
  incorrectExistingPassword: 'error.incorrectExistingPassword',
  unauthorized: 'error.unauthorized',
  invalidCredentials: 'error.invalidCredentials',
  InvalidCredentials: 'error.invalidCredentials',
  invalidParameterValue: 'error.invalidParameterValue',
};
